<template>
  <div class="drone-history-data-container">
    <MCard :title="$t('历史数据')" title-align="center">
      <search :formModel="formModel" :formButton="formButton"></search>
      <MTable
        class="record-table"
        :loading="pageLoading"
        :tableData="tableData"
        :tableColumn="tableColumn"
        :pagiOption="paginationCfg"
        :oprateMenu="oprateMenu"
        max-height="calc(100% - 60px)"
        style="height: calc(100% - 60px)"
      ></MTable>
    </MCard>

    <executeTaskView
      v-if="showTaskDom"
      :taskInfo="taskInfo"
      :boxList="boxList"
      ref="taskDialog"
      @clearTask="taskId = ''"
      @refreshTaskList="searchTableData"
    />

    <el-dialog
      class="page-dilog"
      :title="$t('提示')"
      :visible.sync="delDialog"
      :append-to-body="true"
      width="20%"
    >
      <span>{{ $t('删除内容') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false">{{ $t('取消') }}</el-button>
        <el-button type="danger" @click="delTaskRecordHandler">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dayTime } from '@/utils/utils';
import { formatTime } from '@/utils/date';
import mixins from '../utils/mixins';

import { isEmpty } from '@/utils/is';
import { flightRecoreListServer, deleteFlightMissionRecord } from '@/api/flight-task';
import executeTaskView from '../components/flight-task/execute-task.vue';
import MCard from '@/components/mCard/index.vue';
import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';

let that = null;
export default {
  mixins: [mixins],

  computed: {
    tableColumn() {
      return [
        { prop: 'showSn', label: this.$t('设备') },
        { prop: 'name', label: this.$t('任务名称') },
        { prop: 'pointName', label: this.$t('地址') },
        { prop: 'flightStartTime', label: this.$t('开始时间') },
        { prop: 'flightEndTime', label: this.$t('结束时间') },
        { prop: 'remarks', label: this.$t('备注') }
      ];
    },
    oprateMenu() {
      return {
        label: this.$t('操作'),
        list: [
          {
            text: this.$t('回放'),
            access: () => {
              return true;
            },
            event: (_index, data) => {
              this.toHistoryPageHandler(data);
            }
          }
        ]
      };
    }
  },
  components: {
    MCard,
    Search,
    MTable,
    executeTaskView
  },

  watch: {
    deviceList: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.boxList = newVal;
        }
      }
    }
  },
  filters: {
    filterSn(val) {
      const currentRow = that.boxList.filter(item => {
        return item.sn == val;
      });

      return currentRow[0].name;
    }
  },
  created() {
    that = this;
  },
  data() {
    return {
      that: this,
      pageLoading: true,
      boxList: [],
      formModel: {
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      formButton: [
        {
          text: '查询',
          event: () => {
            this.paginationCfg.offset = 1;
            this.pageLoading = true;
            setTimeout(() => {
              this.searchTableData();
            }, 1000 * 1);
          }
        }
      ],
      paginationCfg: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableData: [],

      taskInfo: null,
      showTaskDom: false,
      delDialog: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.searchTableData();
    }, 1000 * 1);

    let arr = [
      {
        text: this.$t('编辑'),
        access: () => {
          return true;
        },
        event: (_index, data) => {
          this.editRrcordHandler(data);
        }
      },
      {
        text: this.$t('删除'),
        access: () => {
          return true;
        },
        event: async (_index, data, loading) => {
          const btn = loading();

          btn.open();
          this.delDialog = true;
          this.delItem = data;
          btn.close();
        }
      }
    ];
    this.oprateMenu.list = [...this.oprateMenu.list, ...arr];
  },

  methods: {
    searchTableData() {
      const { offset, limit } = this.paginationCfg;

      let beginTimeStr = '';
      let endTimeStr = '';

      let time = this.formModel.rangeDateVal;
      if (!isEmpty(time)) {
        beginTimeStr = formatTime(time[0], 'yyyy-MM-dd hh:mm');
        endTimeStr = formatTime(time[1], 'yyyy-MM-dd hh:mm');
      }

      flightRecoreListServer({ offset, limit, flightMissionId: '', beginTimeStr, endTimeStr })
        .then(res => {
          if (res.code == 200) {
            if (!isEmpty(res.data.list)) {
              res.data.list.forEach((item, index) => {
                this.boxList.forEach(sitem => {
                  if (item.sn === sitem.sn) {
                    res.data.list[index].showSn = sitem.name;
                  }
                });
              });

              this.tableData = res.data.list;
              this.paginationCfg.total = res.data.pageSize;
            } else {
              this.tableData = [];
            }
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    handleCurrentChange(e) {
      this.paginationCfg.offset = e;
      this.searchTableData();
    },
    editRrcordHandler(val) {
      this.taskInfo = val;
      this.showTaskDom = true;
      this.$nextTick(() => {
        this.$refs.taskDialog.visible = true;
      });
    },
    toHistoryPageHandler(val) {
      this.$router.push({
        name: 'history-trajectory',
        query: {
          sn: val.sn,
          beginTime: val.flightStartTime,
          endTime: val.flightEndTime
        }
      });
    },

    delTaskRecordHandler() {
      deleteFlightMissionRecord({ id: this.delItem.id }).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('删除成功'));
          this.tableData.forEach((item, index) => {
            if (item.id == this.delItem.id) {
              this.tableData.splice(index, 1);
            }
          });
          this.delDialog = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.drone-history-data-container {
  height: 100%;
  width: calc(100% - 100px);
  padding: 20px;
  box-sizing: border-box;
  .m-card_content {
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;

    @include scrollar-style-thin;
  }
}
</style>
